const Discountdata = [
  {
    _id: 1,
    cover: "./images/discount/discount-1.png",
    name: "BenuX 2022",
    price: 250,
  },
  {
    _id: 2,
    // cover: "./images/discount/discount-2.png",
    cover: "https://kenyatronics.com/images/getImage/phpDdHwzn/500",
    name: "Sony TV 1080p",
    price: 450,
  },
  {
    _id: 3,
    cover: "./images/discount/discount-3.png",
    name: "Sony PS4",
    price: 50,
  },
  {
    _id: 4,
    cover: "./images/discount/discount-4.png",
    name: "Setgearr 2022",
    price: 100,
  },
  {
    _id: 5,
    cover: "./images/discount/discount-5.png",
    name: "Tony BGB",
    price: 20,
  },
  {
    _id: 6,
    cover: "./images/discount/discount-6.png",
    name: "RG products",
    price: 200,
  },
  {
    _id: 7,
    cover: "./images/discount/discount-7.png",
    name: "Ranasonic 2022",
    price: 300,
  },
  {
    _id: 8,
    cover: "./images/discount/discount-8.png",
    name: "Pune HD",
    price: 30,
  },
  {
    _id: 9,
    cover: "./images/discount/discount-9.png",
    name: "Sony CCTV",
    price: 80,
  },
];
export default Discountdata;
